export default class StringUtils {
    static isEmpty(arg: string | string | undefined | null): boolean {
        return arg == null || arg == "";
    }
}